module.exports = __webpack_public_path__ + "img/settings.7fcf3487.svg";